import * as React from 'react'

import Pagination from "react-js-pagination"
import { Grid } from 'tabler-react'

interface Props {
  handlePageChange: Function
  pageRangeDisplyed:number
  totalItemsCount:number
  itemsCountPerPage:number
  activePage: number
}

const HireXLPagination = (props:Props) => {
  return(
    <React.Fragment>
      <Grid.Row>
        <Grid.Col className='text-center'>
          <Pagination
            activePage={props.activePage}
            hideFirstLastPages
            prevPageText='Prev'
            nextPageText='Next'
            itemsCountPerPage={props.itemsCountPerPage}
            totalItemsCount={props.totalItemsCount}
            pageRangeDisplayed={props.pageRangeDisplyed}
            onChange={props.handlePageChange}
          />
        </Grid.Col>
      </Grid.Row>
    </React.Fragment>
    )
}

export default HireXLPagination